// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import withIconProps from '../withIconProps';

import CheckInCircle from '../_raw/ui/icon_check_in_circle.svg';

export default withIconProps(CheckInCircle);
